import { render, staticRenderFns } from "./ChipRound.vue?vue&type=template&id=3d17bab6&scoped=true"
import script from "./ChipRound.vue?vue&type=script&lang=js"
export * from "./ChipRound.vue?vue&type=script&lang=js"
import style0 from "./ChipRound.vue?vue&type=style&index=0&id=3d17bab6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d17bab6",
  null
  
)

export default component.exports